import { UiResponse } from '../CommonInterfaces';
import { extractQueryStringFromResponse } from './ForwardParamsUtil';
import { urlHasParams } from './NavigationUtil';

export const resolveRedirectUrl = (data: UiResponse, formForwardParams: any) => {
  if (data.redirectUrl) {
    if (urlHasParams(data.redirectUrl)) {
      return data.redirectUrl;
    } else {
      const queryString = extractQueryStringFromResponse(data) || formForwardParams;
      return data.redirectUrl + queryString;
    }
  }
  return null;
};
